import { Directive, Input, OnInit, inject } from '@angular/core';

import { ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsPill } from '@frontend/ui/pill';

import { PillSize, PillVariant } from './types';

@Directive({
    selector: '[msThemedPills]',
})
export class SportsThemedPillsDirective implements OnInit {
    @Input() themedPillSize?: PillSize;
    @Input() themedPillVariant?: PillVariant;
    @Input() themedInverse?: ThemeInverse;
    currentTheme = injectCurrentTheme();
    pill: DsPill = inject(DsPill, {
        self: true,
    });

    ngOnInit(): void {
        const variant = this.themedPillVariant?.[this.currentTheme];
        if (variant) {
            this.pill.variant.set(variant);
        }

        const size = this.themedPillSize?.[this.currentTheme];
        if (size) {
            this.pill.size.set(size);
        }

        const inverse = this.themedInverse?.[this.currentTheme];
        if (inverse) {
            this.pill.inverse.set(inverse.isInverse);
        }
    }
}
